<div class="layout-sidebar" style="border-right: unset !important;">
  <div class="px-3 mt-3">
    <app-product-navigation></app-product-navigation>
  </div>
  <div class="layout-menu-container">
    <app-menu></app-menu>
  </div>
</div>
